import React, { useState, useEffect } from "react";

import {
  Row,
  Button,
  Form,
} from "reactstrap";
import { Colxx, Separator } from "../../components/common/CustomBootstrap";
import { useHistory, Link } from "react-router-dom";
import { ProfileService } from "../../services/ProfileService";

const AppliedJobDetailsScreen = () => {
  const history = useHistory();
  const [jobDetails, setJobDetails] = useState({});
  const [jobType, setJobType] = useState({});
  const [empTerm, setEmpTerm] = useState({});
  let count = 0;
  useEffect(() => {
    getappliedjobdetails();
  }, [count]);

  const getappliedjobdetails = () => {
    ProfileService.getAppliedJobDetailsService().then((response) => {
      try {
        var appliedjobdetails = response.data;
        if (appliedjobdetails !== null) {
          setJobDetails(appliedjobdetails.jobResponse);
          setJobType(appliedjobdetails.jobResponse.jobType);
          setEmpTerm(appliedjobdetails.jobResponse.empTerm);
        }
      } catch (err) {
        console.error("getAppliedJobDetailsService" + JSON.stringify(err));
      }
    });
  };

  const navigate = () => {
    history.push("/appliedjobs");
  };

  return (
    <div className="Container-box">
      <div className="row">
        <div className="col-sm-12">
          <div className="barmenu_content">
            <Form>
              <Row>
                <Colxx xxs="12" xl="12" className="col-left">
                  <div>
                    <Row>
                      <Colxx xxs="12" xl="12" className="col-left">
                        <div className="form-side-profile">
                          <div>
                            <h3> {jobDetails.jobTitle} </h3>

                            <div>
                              <h5>{jobDetails.accountName}</h5>
                            </div>

                            <div>
                              <h5>
                                {"$" +
                                  jobDetails.salaryMin +
                                  "-" +
                                  "$" +
                                  jobDetails.salaryMax +
                                  " |  " +
                                  jobType.value +
                                  " |  " +
                                  empTerm.value}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </Colxx>
                    </Row>
                    <hr></hr>
                    <div>
                      <Row>
                        <Colxx sm={12}>
                          <Row className="ml-3 mb-5 ">
                            <Colxx sm={8} className=" mt-3">
                              <>
                                <div>
                                  <h5> Job Description </h5>

                                  <Separator className="mb-3 mr-1"></Separator>
                                </div>

                                <p>{jobDetails.jobDescription}</p>

                                <hr></hr>

                                <div>
                                  <h5>Job Responsibilities</h5>

                                  <Separator className="mb-3"></Separator>

                                  <p>{jobDetails.jobResponsibilities}</p>
                                </div>
                                <hr></hr>

                                <div>
                                  <h5>Job Requirements</h5>

                                  <Separator className="mb-3"></Separator>
                                  <p>{jobDetails.jobRequirements}</p>
                                </div>

                                <div className="mt-4">
                                  <Button
                                    color="primary"
                                    outline
                                    onClick={navigate}
                                  >
                                    Back To Jobs
                                  </Button>
                                </div>
                              </>
                            </Colxx>
                          </Row>
                        </Colxx>
                      </Row>
                    </div>
                  </div>

                  <div></div>
                </Colxx>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppliedJobDetailsScreen;
